<template>
  <div class="intro-cta row">
    <div :class="[ctaClasses]">
      <component
        :is="link.tag"
        v-if="content.cta?.url"
        :to="link.to"
        :href="link.href"
        :title="content.cta.label"
        :target="link.target"
        class="intro-cta__link"
      >
        <GCtaRounded
          :text="content.cta.label"
          name="read-case"
          :icon="icon"
          size="large"
        />
      </component>
    </div>

    <div :class="[contentClasses]" class="intro-cta__content col-s-offset-1">
      <span
        v-if="content.label"
        class="section-label intro-cta__content__label"
      >
        {{ content.label }}
      </span>
      <Wysiwyg class="intro-cta__content__copy" :content="content"></Wysiwyg>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import { getValue } from '@/modules/colors'
import Wysiwyg from '../Wysiwyg.vue'

const props = defineProps({
  icon: String,
  content: {
    type: Object,
    required: true,
  },
})

const foreground = ref('')
const background = ref('')

const ctaClasses = computed(() =>
  props.content.isFiftyFifty ? ['col-s-5'] : ['col-s-3']
)
const contentClasses = computed(() =>
  props.content.isFiftyFifty
    ? ['col-xxs-12', 'col-s-6']
    : ['col-xxs-12', 'col-s-8']
)
const link = computed(() => {
  const isLink = props.content.cta?.url.includes('http')

  return {
    tag: isLink ? 'a' : 'router-link',
    href: isLink ? props.content.cta?.url : undefined,
    to: isLink ? undefined : props.content.cta?.url,
    target: isLink ? '_blank' : 'self',
  }
})

onMounted(() => {
  foreground.value = getValue('foreground', document.documentElement)
  background.value = getValue('background', document.documentElement)
})
</script>

<style lang="scss" scoped>
.intro-cta__link {
  @include mq($until: s) {
    display: none;
  }
}

.intro-cta__content__label {
  // prettier-ignore
  @include fluid(margin-bottom,(xxs: 20px, xxl: 40px));

  display: block;
}

.intro-cta__content__copy {
  width: 100% !important;
  margin: 0 !important;
}
</style>
